// extracted by mini-css-extract-plugin
export default {"top":"App_top_r8dSw","logo":"App_logo_JPAIa","tabs":"App_tabs_TDbyE","content":"App_content_dRUID","fullHeightTabs":"App_fullHeightTabs_lh9ww"};